<template>
  <b-row>
    <b-col
      lg="6"
      class="mb-3"
    >
      <b-card class="shadow-sm h-100">
        <b-card-title class="d-flex align-items-center">
          <feather-icon
            icon="PieChartIcon"
            size="18"
            class="mr-2 text-muted"
          />
          Distribuição por Status
        </b-card-title>
        <div
          v-for="status in statusDistribution"
          :key="status.label"
          class="mb-2"
        >
          <div class="d-flex justify-content-between align-items-center mb-1">
            <div class="d-flex align-items-center">
              <b-badge
                :variant="status.variant"
                class="mr-2"
              />
              <small class="font-weight-bold">{{ status.label }}</small>
            </div>
            <div>
              <small class="text-muted mr-2">{{ status.count }}</small>
              <b-badge variant="light-secondary">
                {{ status.percentage }}%
              </b-badge>
            </div>
          </div>
          <b-progress
            :value="status.percentage"
            :variant="status.variant"
            height="6px"
            class="mb-2"
          />
        </div>
        <div
          v-if="!statusDistribution.length"
          class="text-center text-muted py-3"
        >
          Nenhum dado disponível
        </div>
      </b-card>
    </b-col>

    <b-col
      lg="6"
      class="mb-3"
    >
      <b-card class="shadow-sm h-100">
        <b-card-title class="d-flex align-items-center">
          <feather-icon
            icon="TagIcon"
            size="18"
            class="mr-2 text-muted"
          />
          Distribuição por Tipo
        </b-card-title>
        <div
          v-for="type in typeDistribution"
          :key="type.label"
          class="d-flex align-items-center justify-content-between p-2 rounded mb-2"
          style="background: #f8f9fa"
        >
          <div class="d-flex align-items-center">
            <div
              class="rounded d-flex align-items-center justify-content-center mr-3"
              :class="type.iconBg"
              style="width: 36px; height: 36px"
            >
              <feather-icon
                :icon="type.icon"
                size="16"
                :class="type.iconColor"
              />
            </div>
            <div>
              <small class="font-weight-bold d-block">{{ type.label }}</small>
              <small class="text-muted">{{ type.description }}</small>
            </div>
          </div>
          <div class="text-right">
            <h4 class="mb-0 font-weight-bolder">
              {{ type.count }}
            </h4>
            <small class="text-muted">agendamentos</small>
          </div>
        </div>
        <div
          v-if="!typeDistribution.length"
          class="text-center text-muted py-3"
        >
          Nenhum dado disponível
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardTitle,
  BBadge,
  BProgress,
} from 'bootstrap-vue'
import agendamentosService from '@/services/agendamentos'
import { statusOptions } from '../calendar-utils'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BBadge,
    BProgress,
  },
  data() {
    return {
      estatisticas: null,
    }
  },
  computed: {
    statusDistribution() {
      const porStatus = this.estatisticas?.mes?.por_status || {}
      const total = Object.values(porStatus).reduce((sum, val) => sum + (Number(val) || 0), 0)

      const statusMap = new Map(statusOptions.map(s => [s.value, s]))

      return Object.entries(porStatus).map(([key, count]) => {
        const countNum = Number(count) || 0
        const normalizedKey = key.toUpperCase()
        const statusConfig = statusMap.get(normalizedKey)

        let label = key.charAt(0) + key.slice(1).toLowerCase().replace(/_/g, ' ')
        let variant = 'secondary'

        if (statusConfig) {
          label = statusConfig.label
          variant = statusConfig.badge.replace('badge-', '')
        }

        return {
          label,
          count: countNum,
          percentage: total > 0 ? Math.round((countNum / total) * 100) : 0,
          variant,
        }
      })
    },
    typeDistribution() {
      const porTipo = this.estatisticas?.mes?.por_tipo || {}

      const tipoLabels = {
        NEGOCIACAO: {
          label: 'Negociação',
          description: 'Reuniões e negociações',
          icon: 'UsersIcon',
          iconBg: 'bg-light-primary',
          iconColor: 'text-primary',
        },
        CONTATO: {
          label: 'Contato',
          description: 'Ligação e contatos',
          icon: 'PhoneIcon',
          iconBg: 'bg-light-info',
          iconColor: 'text-info',
        },
        BOLETO: {
          label: 'Boleto',
          description: 'Emissão e cobrança',
          icon: 'FileTextIcon',
          iconBg: 'bg-light-warning',
          iconColor: 'text-warning',
        },
      }

      return Object.entries(porTipo).map(([key, count]) => {
        const config = tipoLabels[key] || {
          label: key,
          description: key,
          icon: 'TagIcon',
          iconBg: 'bg-light-secondary',
          iconColor: 'text-secondary',
        }
        return {
          ...config,
          count: Number(count) || 0,
        }
      })
    },
  },
  async created() {
    await this.carregarEstatisticas()
  },
  methods: {
    async carregarEstatisticas() {
      try {
        const atendenteId = localStorage.getItem('executivo_id')
        const params = atendenteId ? { atendente_id: atendenteId } : {}
        const response = await agendamentosService.buscarEstatisticasAgendamentos(params)
        this.estatisticas = response?.data || response || {}
      } catch (error) {
        // console.error('Erro ao carregar estatísticas:', error)
      }
    },
  },
}
</script>
